/**
 * The Shopify store's timezone.
 *
 * "Orders today" and "this week" are calendar boundaries in the *store's*
 * zone, not the viewer's — someone reviewing the dashboard from outside
 * India has to see the same day boundary a colleague in Jaipur sees (#406).
 * One constant, imported by the API's SQL translation
 * (`apps/api/src/filters/sql.ts`) and the fixture adapter's local filter
 * engine (`apps/web/src/adapters/fixture/predicate.ts`), rather than
 * `"Asia/Kolkata"` typed out at each call site — the same reasoning that
 * keeps "the last N days" as one operator instead of a boundary computed by
 * hand wherever it is needed.
 */
export const STORE_TIMEZONE = "Asia/Kolkata";
